interface PageTitleProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  className,
  children,
}) => {
  return (
    <>
      <title>{`${title} - ${import.meta.env.VITE_APP_TITLE}`}</title>
      <div className="my-3 flex flex-col justify-between gap-5">
        <h1 className={`${className || ''}`}>{title}</h1>
        {children}
      </div>
    </>
  );
};
